/* SejlStrøm V5.2. Progressive enhancement only. No analytics, cookies or cart writes. */
(() => {
  'use strict';
  if (window.__ssMaritimeV52) return;
  window.__ssMaritimeV52 = true;

  const menuTranslations = {
    'hjem': 'Home',
    'strøm & energi': 'Power & Energy',
    'batterier': 'Batteries',
    'lithium / lifepo4': 'Lithium / LiFePO4',
    'agm-batterier': 'AGM batteries',
    'gel-batterier': 'Gel batteries',
    'opladning & inverter': 'Charging & inverters',
    'inverter/lader': 'Inverter/charger',
    'dc-dc-ladere': 'DC-DC chargers',
    '230 v opladere': '230 V chargers',
    'opladertilbehør': 'Charger accessories',
    'sol & vind': 'Solar & wind',
    'solceller til båd': 'Solar for boats',
    'solceller til fritidshus': 'Solar for holiday homes',
    'fleksible solpaneler': 'Flexible solar panels',
    'små solpaneler': 'Small solar panels',
    'store solpaneler': 'Large solar panels',
    'batteriovervågning': 'Battery monitoring',
    'landstrøm': 'Shore power',
    'kabler & installation': 'Cables & installation',
    'kabler': 'Cables',
    'kabelberegner': 'Cable calculator',
    'strøm- og solcelleberegner': 'Power & solar calculator',
    'varme': 'Heating',
    'alle dieselvarmere': 'All diesel heaters',
    'vælg den rigtige dieselvarmer': 'Choose the right diesel heater',
    'vælg efter oprindelse': 'Choose by origin',
    'produceret i europa': 'Made in Europe',
    'produceret i kina': 'Made in China',
    'dieselvarmere efter mærke': 'Diesel heaters by brand',
    'vandbåren varme': 'Hydronic heating',
    'varmluftsystem': 'Warm-air system',
    'brændstofsystem': 'Fuel system',
    'udstødningssystem': 'Exhaust system',
    'tilbehør & reservedele': 'Accessories & spare parts',
    '1852 tilbehør': '1852 accessories',
    'webasto tilbehør': 'Webasto accessories',
    'display & printplader': 'Controllers & circuit boards',
    'montering & service': 'Installation & service',
    'montering af dieselvarmer': 'Diesel heater installation',
    'dieselvarmer service': 'Diesel heater service',
    'køl & klima': 'Cooling & Climate',
    'kølebokse': 'Coolers',
    'køle- og fryseskabe': 'Fridges & freezers',
    'køle- og fryseskuffer': 'Drawer fridges & freezers',
    'vandvarmere': 'Water heaters',
    'vand & pumper': 'Water & Pumps',
    'trykvandspumper': 'Freshwater pumps',
    'manuelle lænsepumper': 'Manual bilge pumps',
    'navigation & elektronik': 'Navigation & Electronics',
    'kortplottere': 'Chartplotters',
    'ekkolod & transducere': 'Sonar & transducers',
    'autopilot': 'Autopilot',
    'radar': 'Radar',
    'vhf': 'VHF',
    'nmea 2000 & netværk': 'NMEA 2000 & networking',
    'instrumenter & sensorer': 'Instruments & sensors',
    'marine lyd': 'Marine audio',
    'tankmåling': 'Tank monitoring',
    'tanksensorer': 'Tank sensors',
    'septiktanksensorer': 'Holding-tank sensors',
    'belysning': 'Lighting',
    'indendørs belysning': 'Interior lighting',
    'led-spots': 'LED spotlights',
    'loftlamper': 'Ceiling lights',
    'læselamper': 'Reading lights',
    'stemningslys': 'Ambient lighting',
    'lanterner': 'Navigation lights',
    'tilbehør & livsstil': 'Accessories & Lifestyle',
    'guides': 'Guides',
    'kontakt': 'Contact'
  };

  const translateMenu = () => {
    const lang = (document.documentElement.lang || '').toLowerCase();
    if (!lang.startsWith('en')) return;
    document.querySelectorAll('header-component .menu-list__link-title, header-component .menu-list__item, header-component .mega-menu__link-title, header-component .menu-drawer__menu-item-text').forEach(el => {
      const raw = (el.textContent || '').trim();
      const translated = menuTranslations[raw.toLowerCase()];
      if (translated && raw !== translated) el.textContent = translated;
    });
  };

  const markCurrentArea = () => {
    const trail = document.querySelector('.ss-breadcrumbs[data-ss-area-url]');
    document.querySelectorAll('[data-ss-current-area]').forEach(el => el.removeAttribute('data-ss-current-area'));
    if (!trail) return;
    const raw = trail.dataset.ssAreaUrl;
    const title = (trail.dataset.ssAreaTitle || '').trim().toLowerCase();
    let target;
    try { target = new URL(raw, window.location.origin); } catch (_) { return; }
    if (target.origin !== window.location.origin) return;
    const structural = !raw || raw === '#';
    document.querySelectorAll('header-component .menu-list__link,header-component .menu-list__item').forEach(a => {
      if (!(a instanceof HTMLAnchorElement)) return;
      try {
        const url = new URL(a.getAttribute('href'), window.location.origin);
        if (url.origin !== window.location.origin) return;
        const matches = structural ? a.textContent.trim().toLowerCase() === title : url.pathname.replace(/\/$/,'') === target.pathname.replace(/\/$/,'');
        if (matches) a.setAttribute('data-ss-current-area','true');
      } catch (_) { /* Retain the original menu. */ }
    });
  };

  const init = () => {
    translateMenu();
    markCurrentArea();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('popstate', init);

  const watchHeader = () => {
    const header = document.querySelector('header-component');
    if (!header || header.__ssI18nObserver) return;
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        translateMenu();
      });
    });
    observer.observe(header, { childList: true, subtree: true, characterData: true });
    header.__ssI18nObserver = observer;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchHeader, { once: true });
  else watchHeader();
})();
